<!-- eslint-disable max-len -->
<template>
  <div>
    <div style="margin-top: 5px" id="target" v-if="isValidUser">
      <div class="form-row">
          <h3 style="margin: 0;">Accounting Open Invoices</h3>
          <ejs-button
              type="button"
              @click.native="onGetSelectedInvoices"
              cssClass="e-info"
              style="margin-left: 1em; padding: 0.25em 1em;"
          >
            EDIT GROUP
          </ejs-button>
      </div>
      <ejs-grid
        :dataSource="accountingOpenInvoices"
        ref="refAccountingOpenInvoicesGrid"
        :created="gridCreated"
        :allowSorting="true"
        :allowPaging="true"
        :pageSettings="pageSettings"
        :toolbar="toolbarOptions"
        :toolbarClick="toolbarClick"
        :commandClick="cmdOpenInvoiceClick"
        :allowTextWrap="true"
        :textWrapSettings="wrapSettings"
        :excelQueryCellInfo="excelQueryCellInfo"
        :allowExcelExport="true"
        :sortSettings="sortOptions"
        :selectionSettings="gridSelectionOptions"
        :rowDataBound="onGridRowDataBound"
      >
        <e-columns>
          <e-column field="invoiceId" :visible="false" is-primary-key="true" width="0"></e-column>
          <e-column type="checkbox" :headerTemplate="'&nbsp;'" width="80"></e-column>
          <e-column
            headerText="Edit"
            :commands="commands2"
            textAlign="center"
            width="85"
          />
          <e-column field="invoiceNumber" headerText="Invoice #" textAlign="Left" width="140" />
          <e-column
            field="invoiceDate"
            headerText="Invoice Date"
            textAlign="center"
            width="140"
            type="date"
            :format="gridDateFormat"
          />
          <e-column
            field="totalAmount"
            headerText="Invoice Amount"
            textAlign="center"
            width="140"
            format="C2"
          />
          <e-column
            field="totalLevy"
            headerText="Levy Amount"
            textAlign="center"
            width="140"
            format="C2"
          />
          <e-column
            field="invoiceAmount"
            headerText="Total invoice"
            textAlign="center"
            width="140"
            format="C2"
          />
          <e-column
            field="invoiceStatus"
            headerText="Invoice Status"
            textAlign="Left"
            width="160"
          />
          <e-column field="paymentType" headerText="Payment Type" textAlign="Left" width="160" />
          <e-column
            field="userPaymentType"
            headerText="User Payment Type"
            textAlign="Left"
            width="160" />
          <e-column
            field="requestType"
            headerText="Application Type"
            textAlign="Left"
            width="240"
            clipMode="EllipsisWithTooltip"
          />
          <e-column
            field="internalNotes"
            headerText="Internal Comments"
            textAlign="Left"
            width="150"
            clipMode="EllipsisWithTooltip"
          />
          <e-column field="RequestId" headerText="" textAlign="Left" width="0" />
          <e-column
            field="requestor"
            headerText="Applicant Name"
            textAlign="Left"
            width="160"
            clipMode="EllipsisWithTooltip"/>
          <e-column
            field="requestUserEmail"
            headerText="Applicant Email"
            textAlign="Left"
            width="200"
            clipMode="EllipsisWithTooltip"
          />
          <e-column
            field="company"
            headerText="Applicant Company"
            textAlign="Left"
            width="200"
            clipMode="EllipsisWithTooltip"
            />
          <e-column field="siteOwner" headerText="Site Owner" textAlign="Left" width="200" />
          <e-column
            field="siteId"
            headerText="Site Number"
            textAlign="Left"
            width="200"
            clipMode="EllipsisWithTooltip"
            />
          <e-column
            field="siteAddress"
            headerText="Site Address"
            textAlign="Left"
            width="300"
            clipMode="EllipsisWithTooltip"
            />
          <e-column headerText="Invoice" :commands="commands" textAlign="center" width="120" />
          <e-column headerText="Cancel/WO" :commands="commands3" textAlign="center" width="120" />
        </e-columns>
      </ejs-grid>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import {
  GridPlugin,
  Page,
  Toolbar,
  Edit,
  CommandColumn,
  Sort,
  Search,
  ExcelExport,
} from '@syncfusion/ej2-vue-grids';
import { TabPlugin } from '@syncfusion/ej2-vue-navigations';
import { tokenStorage } from '@/shared/storage-service';
import { mapGetters, mapMutations } from 'vuex';
import { reportExportFileName } from '@/utils/report-utils';
import { getInvoicePDF } from '../services/accounting-api';
import { SET_PREVIOUS_ACCOUNTING_TAB, SET_SELECTED_GROUP_INVOICE_IDS } from '../store';

// eslint-disable-next-line import/extensions
import { getDataGridDateFormat, getExcelReportDate } from '../../../utils/date-utils.js';

Vue.use(GridPlugin);
Vue.use(TabPlugin);

export default {
  name: 'AccountingOpenInvoice',
  props: {
    isValidUser: Boolean,
  },
  data() {
    return {
      headerText0: { text: 'Open Invoices' },
      headerText1: { text: 'Closed Invoices' },
      headerText2: { text: 'Historical Invoices' },
      headerText3: { text: 'Refunds' },
      headerText4: { text: 'Credits' },
      sortOptions: { columns: [{ field: 'invoiceDate', direction: 'Descending' }] },
      content0: '#OpenInvoicesTab',
      content1: '#OtherTab',
      commands: [
        {
          type: 'View Invoice',
          buttonOption: {
            cssClass: 'e-flat viewpdfbtn',
            iconCss: 'e-export-pdf e-icons',
          },
        },
      ],
      commands2: [
        {
          type: 'Edit',
          buttonOption: { cssClass: 'e-flat', iconCss: 'e-edit e-icons' },
        },
      ],
      commands3: [
        {
          type: 'Cancel Transaction',
          buttonOption: {
            cssClass: 'e-flat',
            iconCss: 'e-circle-close-fill-3 e-icons',
          },
        },
      ],
      toolbarOptions: ['Search', 'ExcelExport'],
      pageSettings: { pageSize: 10, currentPage: 1 },
      target: '#target',
      wrapSettings: { wrapMode: 'Header' },
      gridDateFormat: getDataGridDateFormat(),
      gridSelectionOptions: { type: 'Multiple', checkboxOnly: true, persistSelection: true },
    };
  },
  computed: {
    ...mapGetters({
      accountingOpenInvoices: 'accountingOpenInvoices',
      loggedUser: 'loggedUser',
    }),
    loggedUserId() {
      return this.loggedUser?.id;
    },
  },
  methods: {
    gridCreated() {
      // Added clear button and its functionalities to Searchbar
      if (this.$refs.refAccountingOpenInvoicesGrid) {
        document
          .getElementById(`${this.$refs.refAccountingOpenInvoicesGrid.$el.id}_searchbar`)
          .addEventListener('keyup', (e) => {
            this.clearSearchEventListener(e, this.$refs.refAccountingOpenInvoicesGrid.$el.id);
          });
      }
    },
    ...mapMutations(['SET_SELECTED_GROUP_INVOICE_IDS']),
    clearSearchEventListener(e, gridId) {
      const searchBtnEle = document.getElementById(`${gridId}_searchbutton`);
      const clearBtnEle = searchBtnEle.cloneNode(true);
      clearBtnEle.id = `${gridId}_clearbutton`;
      clearBtnEle.classList.remove('e-search-icon');
      clearBtnEle.classList.add('e-clear-icon');

      clearBtnEle.addEventListener('click', () => {
        e.target.value = '';
        document.getElementById(`${gridId}_clearbutton`).remove();
      });

      if (e.target.value && searchBtnEle.parentNode.childElementCount === 2) {
        searchBtnEle.parentNode.insertBefore(clearBtnEle, searchBtnEle.parentNode.children[1]);
      } else if (!e.target.value || e.target.value === '') {
        document.getElementById(`${gridId}_clearbutton`).remove();
      }
    },
    onGridRowDataBound(args) {
      if (!args.data) return;

      // Find the checkbox input element within the row
      const checkboxInput = args.row.querySelector('td[role="gridcell"][aria-label="checkbox"] input[type="checkbox"]');

      if (args.data.autoRecoveryGroupId) {
        if (checkboxInput) {
          checkboxInput.disabled = true;
          const checkboxWrapper = checkboxInput.closest('.e-checkbox-wrapper');
          if (checkboxWrapper) {
            checkboxWrapper.classList.add('disablecheckbox');
          }

          // ***Defer manipulating classes using setTimeout***
          // This pushes the execution after the current JS call stack clears.
          setTimeout(() => {
            const inputInTimeout = args.row.querySelector('td[role="gridcell"][aria-label="checkbox"] input[type="checkbox"]');
            const wrapperInTimeout = inputInTimeout ? inputInTimeout.closest('.e-checkbox-wrapper') : null;
            const spanInTimeout = wrapperInTimeout ? wrapperInTimeout.querySelector('.e-frame') : null;

            if (inputInTimeout && inputInTimeout.disabled) {
              if (spanInTimeout) {
                spanInTimeout.classList.remove('e-uncheck');
                spanInTimeout.classList.add('e-check');
              }
            }
          }, 50);
        }
      }
    },
    async cmdOpenInvoiceClick(args) {
      const invoice = args.rowData;
      const { invoiceId } = invoice;
      const accessToken = tokenStorage.getAccessToken();
      // eslint-disable-next-line default-case
      switch (args.commandColumn.type) {
        case 'View Invoice':
          await getInvoicePDF(accessToken, this.loggedUserId, invoiceId).then((res) => {
            window.location.href = `${res.config.baseURL}${res.config.url}`;
          });
          break;
        case 'Edit':
          this.$store.commit(SET_PREVIOUS_ACCOUNTING_TAB, { previousTab: 0 });
          this.$router.push(`/accounting/transactionEdit/${args.rowData.invoiceId}`);
          break;
        case 'Cancel Transaction':
          this.$store.commit(SET_PREVIOUS_ACCOUNTING_TAB, { previousTab: 0 });
          this.$router.push(`/accounting/transactionCancel/${args.rowData.invoiceId}`);
          break;
      }
    },
    excelQueryCellInfo(args) {
      // eslint-disable-next-line default-case
      switch (args.column.field) {
        case 'invoiceDate':
          // eslint-disable-next-line no-param-reassign
          args.value = getExcelReportDate(args.value);
          break;
      }
    },
    toolbarClick(args) {
      // eslint-disable-next-line default-case
      switch (args.item.text) {
        case 'Excel Export':
          this.$refs.refAccountingOpenInvoicesGrid.excelExport({
            fileName: reportExportFileName('Open Invoices.xlsx'),
          });
          break;
      }
    },
    onGetSelectedInvoices() {
      const selectedInvoiceIds = this.getSelectedInvoiceIds();
      this.$store.commit(SET_SELECTED_GROUP_INVOICE_IDS, selectedInvoiceIds);
      this.$store.commit(SET_PREVIOUS_ACCOUNTING_TAB, { previousTab: 0 });
      this.$router.push('/accounting/group-transaction-edit');
    },
    getSelectedInvoiceIds() {
      const grid = this.$refs.refAccountingOpenInvoicesGrid;
      const gridInstance = grid.ej2Instances;

      const selectedInvoiceIDs = gridInstance.selectionModule.persistSelectedData.map(
        (rec) => rec.invoiceId,
      );
      return selectedInvoiceIDs;
    },
  },
  provide: {
    grid: [Page, Edit, Toolbar, CommandColumn, Sort, Search, ExcelExport],
  },
};
</script>

<style>
.disablecheckbox {
    pointer-events: none;
    opacity: 0.5;
}
</style>
